/* upsell-selector v6 (file: v3 — AMP slidecart integration) */
(function () {
  'use strict';

  var TAG = '[upsell v6]';
  window.__upsellSelectorVersion = 'v6';
  try { console.log(TAG, 'boot'); } catch (e) {}

  function openAmpCart() {
    if (window.AMP_API && typeof window.AMP_API.OPEN_CART === 'function') {
      try { console.log(TAG, 'AMP_API.OPEN_CART()'); } catch (e) {}
      try { window.AMP_API.OPEN_CART(); } catch (e) {
        try { console.error(TAG, 'OPEN_CART threw', e); } catch (e2) {}
      }
      return;
    }
    try { console.warn(TAG, 'window.AMP_API.OPEN_CART not available'); } catch (e) {}
  }

  function initWrap(wrap) {
    if (wrap.dataset.upsellInit === '1') return;
    wrap.dataset.upsellInit = '1';
    try { console.log(TAG, 'initWrap on', wrap.id || '(no id)'); } catch (e) {}

    var opts = wrap.querySelectorAll('.upsell-selector__option');
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('selected'); });
        o.classList.add('selected');
      });
    });

    var mainVariants = [];
    try { mainVariants = JSON.parse(wrap.dataset.mainVariants || '[]'); } catch (e) {}

    function readMainVariantId() {
      var inputs = document.querySelectorAll('input[name="id"], select[name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        var v = parseInt(inputs[i].value, 10);
        if (!isNaN(v)) {
          for (var j = 0; j < mainVariants.length; j++) {
            if (mainVariants[j].id === v) return v;
          }
        }
      }
      try {
        var urlVariant = new URLSearchParams(window.location.search).get('variant');
        if (urlVariant) {
          var pv = parseInt(urlVariant, 10);
          for (var k = 0; k < mainVariants.length; k++) {
            if (mainVariants[k].id === pv) return pv;
          }
        }
      } catch (e) {}
      if (inputs.length > 0) {
        var fv = parseInt(inputs[0].value, 10);
        if (!isNaN(fv)) return fv;
      }
      return null;
    }

    function getMainSelectedOpts() {
      var vid = readMainVariantId();
      if (!vid) return null;
      for (var i = 0; i < mainVariants.length; i++) {
        if (mainVariants[i].id === vid) return mainVariants[i].opts || {};
      }
      return null;
    }

    function resolveUpsellIds(sel) {
      var productsJson = sel ? sel.dataset.upsellProducts : '';
      if (!productsJson) return [];
      var products;
      try { products = JSON.parse(productsJson); } catch (e) { return []; }
      var mainOpts = getMainSelectedOpts() || {};
      return products.map(function (p) {
        var match = null;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          var ok = true;
          for (var key in mainOpts) {
            if (Object.prototype.hasOwnProperty.call(v.opts, key) && v.opts[key] !== mainOpts[key]) {
              ok = false; break;
            }
          }
          if (ok) { match = v.id; break; }
        }
        return match || p.fallback;
      });
    }

    function isUpsellSelected() {
      var sel = wrap.querySelector('.upsell-selector__option.selected');
      if (!sel) return false;
      var includeMain = sel.dataset.includeMain !== 'false';
      return !includeMain && !!(sel.dataset.upsellProducts || sel.dataset.upsellIds);
    }

    function cartAddBundle(upsellIds) {
      var body = { items: upsellIds.map(function (id) { return { id: id, quantity: 1 }; }) };
      try { console.log(TAG, 'POST /cart/add.js', body); } catch (e) {}
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, data: j }; }); })
        .then(function (res) {
          try { console.log(TAG, 'cart/add.js result', res); } catch (e) {}
          openAmpCart();
          return res.data;
        })
        .catch(function (err) {
          try { console.error(TAG, 'cart/add.js failed', err); } catch (e) {}
        });
    }

    function isProductAddButton(target) {
      if (!target || !target.closest) return null;
      var btn = target.closest('button[type="submit"][name="add"], button[name="add"], [data-add-to-cart]');
      if (btn) return btn;
      var submitBtn = target.closest('button[type="submit"]');
      if (submitBtn && submitBtn.closest('hdt-buy-buttons')) return submitBtn;
      return null;
    }

    var inFlight = false;
    function handleAtcClick(e) {
      if (!isUpsellSelected()) return;
      var btn = isProductAddButton(e.target);
      if (!btn) return;
      if (inFlight) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }
      var sel = wrap.querySelector('.upsell-selector__option.selected');
      var upsellIds = resolveUpsellIds(sel);
      if (!upsellIds || upsellIds.length === 0) {
        try { console.warn(TAG, 'no upsell ids; letting click through'); } catch (e2) {}
        return;
      }
      inFlight = true;
      setTimeout(function () { inFlight = false; }, 2000);
      var origin = e.currentTarget === window ? 'window' : (e.currentTarget === document ? 'document' : 'other');
      try { console.log(TAG, 'INTERCEPT @' + origin + ' phase=' + e.eventPhase, 'ids=', upsellIds); } catch (e2) {}
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      cartAddBundle(upsellIds);
    }

    window.addEventListener('click', handleAtcClick, true);
    document.addEventListener('click', handleAtcClick, true);
  }

  function init() {
    var wraps = document.querySelectorAll('.upsell-selector');
    try { console.log(TAG, 'init: found ' + wraps.length + ' wrap(s)'); } catch (e) {}
    wraps.forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
